import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Observable, Subject } from 'rxjs';
import {
  BaseAuthenticatedService,
  httpQueryParams,
  PaginatedResponse,
  RecursiveInterface,
} from './base-authenticated.service';
import { SavedProductInterface } from '@app/interface/savedproduct';

@Injectable({
  providedIn: 'root',
})
export class SavedProductsApi extends BaseAuthenticatedService {
  constructor(
    public override auth: AngularFireAuth,
    public override httpClient: HttpClient, // private cookieService: CookieService
  ) {
    super(auth, httpClient);
  }

  // using getRecursivePage
  public getAllSavedProducts<T = SavedProductInterface>(
    organization_id: number | null,
    params: httpQueryParams = {},
  ): Subject<RecursiveInterface<T>> {
    const path = `api/${organization_id}/saved-product/`;
    return this.getRecursivePage<T>(path, params);
  }

  public createSavedProduct(
    organization_id: number | null,
    productData: Partial<SavedProductInterface>,
  ): Observable<SavedProductInterface> {
    if (!productData.organization_id) {
      productData.organization_id = 1; // Default to company with ID 1
    } else {
      organization_id = productData.organization_id;
    }
    const path = `api/${organization_id}/saved-product/`;

    return this.post<SavedProductInterface>(path, {}, productData);
  }

  public updateSavedProductDetails(
    organization_id: number | null,
    id: number,
    data: Partial<SavedProductInterface>,
  ): Observable<SavedProductInterface> {
    console.log(data);
    return this.partialUpdate<SavedProductInterface>(
      `api/${organization_id}/saved-product/${id}/`,
      {}, //{ withCredentials: true },
      data,
    );
  }
}
